import Navbar from "../components/Navbar";
import "./Termini.css";

export default function Termini() {
  return (
    <div className="termini-container">
      <Navbar backButton />

      <div className="termini-content">
        <h1 className="termini-title">Termini e Condizioni</h1>

        <div className="termini-intro">
          <p>
            <strong>
              Unitiva Game - Unitiva S.r.l. x S.S. Napoli Basket s.r.l.
            </strong>
          </p>
          <p>Data di entrata in vigore: 16 novembre 2025</p>
        </div>

        <div className="termini-section">
          <h2>1. Titolare del trattamento e contatti</h2>
          <p>
            L'applicazione "Unitiva Game" è gestita da{" "}
            <strong>UNITIVA S.r.l.</strong>, con sede legale in Via Medina 40 –
            80133 Napoli (NA).
          </p>
          <p>
            <strong>Contatti:</strong>
          </p>
          <ul>
            <li>
              Email: <a href="mailto:info@unitiva.it">info@unitiva.it</a>
            </li>
            <li>Telefono: +39 081 65 81 180</li>
          </ul>
        </div>

        <div className="termini-section">
          <h2>2. Scopo dell'app</h2>
          <p>
            L'app "Unitiva Game" consente ai tifosi di partecipare a un gioco
            interattivo durante le partite del S.S. Napoli Basket s.r.l., con la
            possibilità di vincere premi e vivere un'esperienza digitale e
            reale.
          </p>
        </div>

        <div className="termini-section">
          <h2>3. Registrazione e dati raccolti</h2>
          <p>
            Per partecipare al gioco è richiesta una registrazione rapida
            tramite profili social (Google o Facebook).
          </p>
          <p>In fase di registrazione vengono raccolti:</p>
          <ul>
            <li>
              l'indirizzo email o l'identificativo del profilo Google/Facebook;
            </li>
            <li>eventuali dati di navigazione e punteggi di gioco;</li>
            <li>
              il consenso al trattamento dei dati per finalità di gioco e
              comunicazioni promozionali.
            </li>
          </ul>
        </div>

        <div className="termini-section">
          <h2>4. Consenso alle comunicazioni</h2>
          <p>
            Accedendo e utilizzando l'app, l'utente autorizza UNITIVA S.r.l. e
            S.S. Napoli Basket s.r.l. a inviare comunicazioni relative all'app,
            al gioco, agli eventi e ad altre iniziative promozionali correlate.
          </p>
        </div>

        <div className="termini-section">
          <h2>5. Uso dell'app e comportamenti consentiti</h2>
          <p>
            L'utente si impegna a utilizzare l'app esclusivamente per scopi
            leciti e conformi alla legge, evitando qualsiasi uso improprio,
            manipolazione del punteggio o interferenza con il sistema di gioco.
          </p>
        </div>

        <div className="termini-section">
          <h2>6. Contenuti e condivisione sui social</h2>
          <p>
            I partecipanti possono condividere screenshot o video del gioco sui
            propri profili social e taggare UNITIVA S.r.l. e S.S. Napoli Basket
            s.r.l.
          </p>
          <p>
            Condividendo contenuti pubblici con tali tag, l'utente concede a
            UNITIVA S.r.l. e S.S. Napoli Basket s.r.l. il diritto non esclusivo
            e gratuito di utilizzare tali contenuti per fini promozionali (ad
            esempio repost o stories), sempre nel rispetto dell'immagine
            dell'utente e delle norme vigenti.
          </p>
        </div>

        <div className="termini-section">
          <h2>7. Premi e classifiche</h2>
          <p>
            I primi tre classificati nel gioco potranno partecipare ad attività
            sul parquet o ricevere premi ufficiali del S.S. Napoli Basket s.r.l.
          </p>
          <p>
            UNITIVA S.r.l. si riserva di verificare la regolarità dei punteggi e
            di escludere chi adotti comportamenti scorretti o non conformi ai
            presenti Termini.
          </p>
        </div>

        <div className="termini-section">
          <h2>8. Condotta dell'utente</h2>
          <p>È vietato utilizzare l'app per:</p>
          <ul>
            <li>Attività illegali o fraudolente</li>
            <li>Violare i diritti di terzi</li>
            <li>Diffondere contenuti offensivi, diffamatori o inappropriati</li>
            <li>Interferire con il funzionamento dell'app</li>
            <li>Accedere a parti non autorizzate del sistema</li>
          </ul>
          <p>La violazione di queste norme può comportare:</p>
          <ul>
            <li>Sospensione o cancellazione dell'account</li>
            <li>Squalifica dalla competizione</li>
            <li>Esclusione dall'evento</li>
            <li>Azioni legali se applicabile</li>
          </ul>
          <p>
            <strong>È espressamente vietato:</strong>
          </p>
          <ul>
            <li>
              Utilizzare bot, script automatizzati o qualsiasi sistema per
              giocare al posto dell'utente
            </li>
            <li>
              Creare o utilizzare account multipli per aumentare le proprie
              possibilità di vincita
            </li>
            <li>
              Manipolare i punteggi, la classifica o il funzionamento del gioco
              in qualsiasi modo
            </li>
            <li>
              Condividere le proprie credenziali di accesso con altri utenti
            </li>
            <li>
              Interferire con il corretto funzionamento dell'app o con
              l'esperienza di altri partecipanti
            </li>
          </ul>
          <p>
            <strong>Conseguenze:</strong> la violazione di queste regole
            comporta:
          </p>
          <ul>
            <li>Squalifica immediata dal gioco</li>
            <li>Cancellazione dell'account</li>
            <li>Perdita di eventuali premi vinti</li>
            <li>Possibile esclusione da future iniziative</li>
          </ul>
          <p>
            UNITIVA S.r.l. si riserva il diritto di verificare la regolarità dei
            punteggi e delle registrazioni, e di escludere chi adotti
            comportamenti scorretti o non conformi ai presenti Termini.
          </p>
        </div>

        <div className="termini-section">
          <h2>9. Tutela dei dati personali</h2>
          <p>
            I dati raccolti saranno trattati in conformità al Regolamento (UE)
            2016/679 (GDPR) e alla normativa nazionale vigente, esclusivamente
            per le finalità connesse al funzionamento dell'app e alle attività
            promozionali indicate.
          </p>
          <p>
            Partecipando al gioco, l'utente autorizza Unitiva S.r.l. e S.S.
            Napoli Basket s.r.l. a:
          </p>
          <ul>
            <li>Riprendere e fotografare la sua partecipazione</li>
            <li>
              Utilizzare tali contenuti per scopi promozionali, marketing e
              comunicazione sui propri canali (social media, sito web, eventi)
            </li>
            <li>
              Pubblicare il nome e/o nickname dell'utente in relazione
              all'evento
            </li>
          </ul>
          <p>
            L'utente potrà in ogni momento esercitare i diritti di accesso,
            rettifica o cancellazione dei propri dati, scrivendo a{" "}
            <a href="mailto:privacy@unitiva.it">privacy@unitiva.it</a>.
          </p>
        </div>

        <div className="termini-section">
          <h2>10. Responsabilità</h2>
          <p>
            UNITIVA S.r.l. non potrà essere ritenuta responsabile per eventuali
            malfunzionamenti tecnici, interruzioni di servizio o perdite di dati
            dovute a cause indipendenti dalla propria volontà.
          </p>
          <p>L'utente è l'unico responsabile per:</p>
          <ul>
            <li>Il proprio dispositivo e la connessione internet</li>
            <li>La propria condotta durante l'evento</li>
            <li>
              La partecipazione ai tiri liberi sul parquet (infortuni, danni)
            </li>
          </ul>
          <p>UNITIVA S.r.l. non è responsabile per:</p>
          <ul>
            <li>Problemi tecnici del dispositivo dell'utente</li>
            <li>Interruzioni della connessione internet</li>
            <li>Danni diretti o indiretti derivanti dall'utilizzo dell'app</li>
            <li>Perdita di dati o contenuti</li>
            <li>Comportamenti di altri utenti</li>
          </ul>
          <p>
            La responsabilità massima di UNITIVA S.r.l. è limitata al valore del
            premio eventualmente vinto.
          </p>
        </div>

        <div className="termini-section">
          <h2>11. Modifiche ai Termini</h2>
          <p>
            UNITIVA S.r.l si riserva il diritto di modificare o aggiornare in
            qualsiasi momento i presenti Termini e Condizioni. Le modifiche
            saranno comunicate tramite l'app o il sito ufficiale.
          </p>
        </div>
      </div>
    </div>
  );
}
